<template>
  <v-btn
    :disabled="disabled"
    :variant="variant"
    :loading="loading"
    :block="block"
    :size="size"
    :color="color"
    :elevation="elevation"
    :active="active"
    :slim="slim"
    data-cc="BMButton"
    @click="$emit('clicked')"
  >
    <template v-if="$slots.pre" #prepend>
      <slot name="pre" />
    </template>
    <template v-if="$slots.append" #append>
      <slot name="append" />
    </template>
    <slot name="html" />
    {{ title }}
  </v-btn>
</template>

<script setup lang="ts">
import type { ComponentVariant } from '@/types/theme';

interface Props {
  disabled?: boolean;
  title?: string;
  size?: string;
  color?: string;
  variant?: ComponentVariant;
  loading?: boolean;
  block?: boolean;
  elevation?: number | string;
  active?: boolean;
  slim?: boolean;
}

withDefaults(defineProps<Props>(), {
  active: false,
  disabled: false,
  title: '',
  size: 'default',
  color: 'primary',
  variant: 'flat',
  loading: false,
  block: false,
  elevation: 0,
  slim: false
});

defineEmits<{
  (e: 'clicked'): void;
}>();
</script>
